import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { useNavigate } from "react-router";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const CustomMenu = styled(MenuItem)({
  height: "41px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: "#1A1824",
});


export default function CustomizedMenus({ value, items = [], onClick, id }) {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    // console.log('event.currentTarget', event.currentTarget)
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [Value, setValue] = React.useState("Action")
  const findLabel = (label, items) => {
    const index = items.findIndex((e) => e.id === label);
    // console.log("label", label)

    console.log("items[index].label", items[index]?.label)
    setValue(items[index]?.label)
    return items[index] && items[index]?.label;
    // return label
  };
  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDownIcon />}
        sx={{
          border: "1px solid #559A95",
          fontFamily: "Outfit",
          fontStyle: "normal",
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "160%",
          letterSpacing: "0.015em",
          color: open ? "#ffffff" : "#2B817B",
          textTransform: "none",
          backgroundColor: open ? " #559A95" : undefined,
        }}
      >
        {Value}
        {/* {findLabel(value, items)} */}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {items.map((item) => (
          <CustomMenu
            onClick={() => {
              handleClose();
              navigate(`/Mealplan/${id}`)
              // onClick(item.id);
              findLabel(item.id, items);
            }}
            style={{ color: item.color }}
            disableRipple
          >
            <Box style={{ paddingRight: "10px" }}>
              <i class={item.icon}></i>
            </Box>
            {item.label}
          </CustomMenu>
        ))}
      </StyledMenu>
    </div>
  );
}
